/**
 * Shared email capture pill styling — Figma 4074:23618 (homepage hero mobile).
 * Used by the homepage hero, funding eligibility step 02, growth stories, and
 * research download forms.
 */
export const EMAIL_CAPTURE_PILL_FORM_CLASS =
  "flex w-full min-w-0 items-center justify-between rounded-full border py-1 pr-1 pl-4";

export const EMAIL_CAPTURE_PILL_INPUT_CLASS =
  "text-ds-label-lg text-grey-950 placeholder:text-grey-300 min-w-0 flex-1 bg-transparent font-medium outline-none";

/**
 * Pill row plus a reserved validation-message line. The fixed space prevents
 * the funding eligibility card from shifting when an email error appears.
 */
export const EMAIL_CAPTURE_PILL_HEIGHT_CLASS = "h-[72px]";
